/* eslint-disable max-len */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
import React from 'react';

export default function TransferHistory({ OrderDetails }) {
    function formatTimestamp(timestamp) {
        const date = new Date(timestamp * 1000); // convert seconds → ms

        return date
            .toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            })
            .replace(',', ''); // remove the comma
    }
    return (
        <div className="border border-[#CBC7C7] rounded-md bg-[#F5F5FA] h-auto p-3 my-4">
            <p className="font-semibold text-base text-[#090406]">Transfer History</p>
            {OrderDetails?.transfer_history && OrderDetails?.transfer_history.length > 0
                && OrderDetails?.transfer_history.map((transferDetails, index) => (
                    <div key={transferDetails} className={`${index !== OrderDetails.transfer_history.length - 1 ? ' pb-2 mb-2 border-b border-[#CBC7C7]' : ''}`}>
                        <div className="text-[14px] flex gap-2">
                            <p className="text-[#090406] font-semibold whitespace-nowrap">
                                Transferred by:
                                {' '}
                            </p>
                            <p className="text-wrap text-[#555259]">
                                {transferDetails?.transferred_by?.name}
                                {' '}
                                {`(${transferDetails?.transferred_by?.employee_code})`}
                            </p>
                        </div>
                        <div className="text-[14px] flex gap-2">
                            <p className="text-[#090406] font-semibold whitespace-nowrap">
                                Transferred to:
                            </p>
                            <p className="text-wrap text-[#555259]">
                                {transferDetails?.transferred_to?.name}
                                {' '}
                                {`(${transferDetails?.transferred_to?.employee_code})`}
                            </p>
                        </div>
                        <div className="text-[14px] flex gap-2">
                            <p className="text-[#090406] font-semibold whitespace-nowrap">
                                Date and Time:
                            </p>
                            <p className="text-wrap text-[#555259]">
                                {transferDetails?.transferred_at ? formatTimestamp(transferDetails?.transferred_at) : '-'}
                            </p>
                        </div>
                        <div className="text-[14px] flex gap-2">
                            <p className="text-[#090406] font-semibold">
                                Note:
                            </p>
                            <p className="text-wrap text-[#555259] break-all">
                                {transferDetails?.comment || '-'}
                            </p>
                        </div>
                    </div>
                ))}
        </div>
    );
}
